import { Pipe, PipeTransform } from '@angular/core';
import { SaleHorseModel } from '../models/sale-horse.model';

@Pipe({
  name: 'filterHorsesBySale',
  pure: false,
})
export class FilterSaleHorsePipe implements PipeTransform {
  transform(saleHorses: SaleHorseModel[], saleId: number): any {
    return saleHorses.find((sh) => sh.saleId === saleId)?.horses || [];
  }
}
